// @owners { team: patients }
import { Body, Column, LoadingEmptyState } from '@alto/design-system';
import { CommsVerificationFail, CommsVerificationSuccess } from '@alto/features';
import * as React from 'react';
import { type COMMS_CHANNEL } from '~shared/constants';

type Props = {
  readonly loading: boolean;
  readonly isVerified: boolean | null | undefined;
  readonly commsChannel: keyof typeof COMMS_CHANNEL;
  readonly token: string;
  readonly authorized: boolean;
};

const Loading = () => (
  <Column
    flexGrow={1}
    center
    gap="SM"
  >
    <Body>Verifying...</Body>
    <LoadingEmptyState />
  </Column>
);

export const CommsVerificationStatus = ({ loading, isVerified, commsChannel, token, authorized }: Props) => {
  if (loading) return <Loading />;

  if (isVerified) {
    return (
      <CommsVerificationSuccess
        commsChannel={commsChannel}
        authorized={authorized}
      />
    );
  }

  return (
    <CommsVerificationFail
      commsChannel={commsChannel}
      token={token}
      authorized={authorized}
    />
  );
};
